module.exports = "<div class=\"container\">\r\n\t<h1>Chybička se vloudila</h1>\r\n\t<p>\r\n\t\t...\r\n\t</p>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/p500.component.html
// module id = 464
// module chunks = 11